/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { FractionDependencies } from './dependenciesFractionClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFraction } from '../../factoriesAny.js';
export var fractionDependencies = {
  FractionDependencies: FractionDependencies,
  typedDependencies: typedDependencies,
  createFraction: createFraction
};